import { Menu, Modal } from "antd";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import "./sideMenu.css";
import { checkRouteName } from "../../utills";
import Person from "../../assets/images/logo.png";
import { IoPersonCircleOutline } from "react-icons/io5";
import { isLogin } from "../../Store/Actions/AuthAction";
import { RxHome } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { BsCardChecklist } from "react-icons/bs";
import { CiLogout } from "react-icons/ci";
import { IoBookOutline } from "react-icons/io5";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import { PiCoins } from "react-icons/pi";
import { AiOutlineCloseCircle, AiOutlineInfoCircle } from "react-icons/ai";
import styles from './sideMenu.css'
import SubmitButton from "../submitButton/SubmitButton";
import { useState } from "react";
import TextComponent from "../../components/textComponent/TextComponent";

const menuStyle = {
  borderRadius: 0,
  width: "100%",
  margin: 0,
  paddingLeft: 0,
  borderTopLeftRadius: "0px",
  borderBottomLeftRadius: "0px",
  fontFamily: "var(--font-family)",
  backgroundColor: "var(--sideMenu-item-color)",
  
};


const SideMenu = ({ collapsed, onBackClick }) => {


   const logout = () => {
    dispatch(isLogin(false));
    localStorage.clear();
  };

  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();
  const [openLogoutModal, setopenLogoutModal] = useState(false)

  const { height, width } = useWindowDimensions();

const adminMenu = ({ navigation, dispatch, t }) => {


  return [
    {
      style: menuStyle,
      key: "AdminDashboard",
      icon: (
        <RxHome className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Home</h4>,
      onClick: () => {
        navigation("/AdminDashboard");
      },
    },
    {
      style: menuStyle,
      key: "YardSales",
      icon: (
       <BsCardChecklist className='sidebarIcon' />

      ),
      label: <h4 className="menu-lable">YardSales </h4>,
      onClick: () => navigation("/YardSales"),
    },
     {
      style: menuStyle,
      key: "Payments",
      icon: (
       <PiCoins className='sidebarIcon' />

      ),
      label: <h4 className="menu-lable">Payments </h4>,
      onClick: () => navigation("/Payments"),
    },

    {
      style: menuStyle,
      key: "Setting",
      icon: (
        <IoSettingsOutline className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Settings</h4>,
      onClick: () => navigation("/Setting"),
    },

     {
      style: menuStyle,
      key: "TermsConditions",
      icon: (
        <IoBookOutline className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Terms & Conditions</h4>,
      onClick: () => navigation("/TermsConditions"),
    },

      {
      style: menuStyle,
      key: "PrivacyPolicy",
      icon: (
        <MdOutlinePrivacyTip className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Privacy Policy</h4>,
      onClick: () => navigation("/PrivacyPolicy"),
    },
        {
      style: menuStyle,
      key: "About",
      icon: (
        <AiOutlineInfoCircle className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">About Us</h4>,
      onClick: () => navigation("/About"),
    },

    {
      style: menuStyle,
      key: "HelpSupport",
      icon: (
        <BiSupport className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Help Support Queries</h4>,
      onClick: () => navigation("/HelpSupport"),
    },
        {
      style: menuStyle,
      key: "WebsiteQueries",
      icon: (
        <BiSupport className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">Website Queries</h4>,
      onClick: () => navigation("/WebsiteQueries"),
    },

     {
      style: menuStyle,
      key: "FAQs",
      icon: (
        <IoIosHelpCircleOutline className='sidebarIcon' />
      ),
      label: <h4 className="menu-lable">FAQs</h4>,
      onClick: () => navigation("/FAQs"),
    },

    {
      style: menuStyle,
      key: "Logout",
      icon: ( 
          <CiLogout className='sidebarIcon'  /> 
      ),
      label: <h4 className="menu-lable">Logout</h4>,
      onClick: () => setopenLogoutModal(true),
    },
  ];
};

  return (
    <div className="menu-main-container">
      <div className="logo_container">
        {collapsed || width < 786 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
            }}
          >
            <img
              src={Person}
              alt="logo"
              style={{ width: "60%", height: "60%" }}
              onClick={() => navigate("/AdminProfile")}
            />
            <div onClick={() => navigate("/AdminEditProfile")}>
              <IoPersonCircleOutline color="var(--white-color)" />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 5,
              cursor: "pointer",
            }}
          >
            <img
              src={Person}
              alt="logo"
              style={{ width: "60%", height: "60%" }}
              onClick={() => navigate("/AdminProfile")}
            />        
          </div>
        )}
      </div>
      <Menu
        _internalDisableMenuItemTitleTooltip
        className={`${collapsed ? "menu-colapsed" : "menu"}`}
        mode={"inline"}
        inlineCollapsed={width >= 786 ? collapsed : false} 
        defaultSelectedKeys={checkRouteName(location.pathname?.substring(1))}
        selectedKeys={checkRouteName(location.pathname?.substring(1))}
        defaultOpenKeys={["AdminDashboard"]} 
        items={adminMenu({ navigation, dispatch})}
      />

       <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={openLogoutModal}
        onCancel={()=>{
            setopenLogoutModal(false)
        }}
      >
        <div className={styles.modal}>
            <TextComponent text={"Logout"} className={'modalheading'}/>
            <TextComponent text={"Are you sure you want to logout ?"} className={'modalText'}/>

         
        <div className={'modalFooter'}>

          <SubmitButton
            title={"No"}
            btnClass={'modalBtn'}
            primary
            onClick={() => setopenLogoutModal(false)}
          />

           
          <SubmitButton
            title={"Yes"}
            btnClass={'modalBtn'}
            secondaryBtn
            onClick={logout}
          />
        </div>

        </div>
      </Modal>

    </div>
  );
};

export default SideMenu;
